<template lang="pug">
div.slick-wrapper(
    v-observe-visibility="observeVisibilityOptions")

    slick(
        v-bind:ref="ref"
        v-bind:options="slickOptions"
        v-bind:class="className"
        v-on:beforeChange="handleBeforeChange"
        v-on:afterChange="handleAfterChange")
        div(v-for="(item, index) in items" v-bind:key="rand + index")
            slot(name="slide-card" v-bind:item="item" v-bind:index="index")

    //- div {{ `${currentSlide + 1} / ${items.length}` }}

</template>

<script>
import Slick from 'vue-slick';

// Slick carousel styles
import 'slick-carousel/slick/slick.css';
import 'assets/styles/slick-theme.scss';

import IntersectionObserverMixin from '@/components/Base/IntersectionObserverMixin';

export default {
    name: 'slick-slides',

    props: {
        items: {        type: Array[Object], required: true },
        options: {      type: Object, default: function () { return {}; } },
        className: {    type: String, default: 'slick' }
    },

    mixins: [ IntersectionObserverMixin ],

    components: {
        Slick
    },

    computed: {
        rand: function () {
            return _.random(10000);
        }
    },

    data: function () {
        return {
            ref: 'slick',
            currentSlide: 0,
            slickOptions: _.extend({}, {
                slidesToShow: 3,
                slidesToScroll: 3,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: false,
                speed: 2000,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 1500
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            }, this.options)
        };
    },

    created: function () {
        this.ref = 'slick' + this.rand;
    },

    mounted: function () {
        this.$eventBus.$on('slides-reset', this.reSlick);
    },

    beforeDestroy: function () {
        this.$eventBus.$off('slides-reset', this.reSlick);
    },

    watch: {
        items: function () {
            this.reInit();
        }
    },

    methods: {
        reInit: function () {
            // re-create slick after update in dynamic list
            // just reSlick() is not enough
            this.$refs[this.ref].destroy();
            this.$nextTick(() => {
                this.$refs[this.ref].create();
                this.$refs[this.ref].goTo(0, true);
            });
        },

        reSlick: function () {
            this.$refs[this.ref] && this.$refs[this.ref].reSlick();
        },

        handleBeforeChange: function (event, slick, currentSlide, nextSlide) {
            this.$emit('before-change', nextSlide);
        },

        handleAfterChange: function (event, slick, currentSlide) {
            this.$emit('after-change', currentSlide);
            // this.currentSlide = currentSlide;
        },

        onIntersectShow: function () {
            this.$nextTick(() => {
                this.reSlick();
            });
        },

        onIntersectHide: function () {}
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/variables';

.slick-track {
    height: auto; // this might be dangerous but important for some views!
    min-height: 400px;
    @media screen and (max-width: $breakpoint-mobile - 1) {
        min-height: 200px;
    }
}
.slick-slide {
    max-height: 200px;
    margin: 0;
    margin-right: 0.5rem;
    // hidden large slides should not take too much space
    transition: ease-out;
    transition-duration: 2750ms;
    transition-delay: 75ms;
    &.slick-active {
        height: auto;
        max-height: 200vh;
    }
    &.slick-active > div:last-child {
        margin-right: 0;
    }
    .card-image figure {
        height: inherit;
    }
    img {
        width: inherit;
        height: inherit;
        max-width: 100%;
        min-height: inherit;
        max-height: inherit;
    }
}
.slick-prev, .slick-next {
    top: 42%;
}

/**
 * Responsive card with social button inside the header
 */
@media screen and (max-width: $breakpoint-desktop - 1) {
    .slick-track {
        .card.card-social-header {
            .card-header-title {
                max-width: unset;
            }
            .card-link {
                flex-direction: column !important;
                .social-button-wrapper {
                    margin: 0.5rem 0;
                    margin-left: auto;
                }
            }
        }
    }
}
</style>
